/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_OffsetInputs */



/**
* | output |
* | --- |
* | "Timecode Offset..." |
*
* @param {Timecode_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_offset = /** @type {((inputs?: Timecode_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décalage du code temporel...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcode-Offset...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset del codice temporale...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смещение временного кода...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento del código de tiempo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码偏移...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード オフセット...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड ऑफ़सेट...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento do código de tempo...")
	return /** @type {LocalizedString} */ ("Timecode Offset...")
});